<modal-component [fullWidth]="true">

	<!-- LEFT-->
	<ng-container left>

		<ng-container *ngIf="!controller.showConfirmation">
			<div class="_header">
				<p *ngIf="controller.action === 'create'" class="_title" [translate]="controller.type === controller.EventAttendanceType.Reservation ? 'RESERVATION.CREATE' : 'REGISTRATION.CREATE'">
				</p>
				<p *ngIf="controller.action === 'update'" class="_title" [translate]="controller.type === controller.EventAttendanceType.Reservation ? 'RESERVATION.EDIT' : 'REGISTRATION.EDIT'" >
				</p>
				<p class="_subtitle _ended" *ngIf="controller.isInPast">{{'EVENT.ENDED' | translate}}</p>
			</div>
	
			<!-- info or context -->

			<div class="_info" *ngIf="controller.type === controller.EventAttendanceType.Reservation || controller.EventAttendanceType.Registration">
				<info-line icon="./assets/icons/calendar-outline.svg">
					<p>{{controller.calendarEvent.Event?.name}} ({{controller.calendarEvent.Event?.EventType?.name}})</p>
				</info-line>				
				<ng-container *ngIf="controller.reservation?.startsAt && controller.reservation?.endsAt">
					<info-line icon="./assets/icons/calendar-outline.svg">
						<p>{{controller.reservation.startsAt | date:"EEEE d MMM yyyy"}} | {{controller.reservation.startsAt | date:"HH:mm"}} - {{controller.reservation.endsAt | date:"HH:mm"}}</p>
					</info-line>				
				</ng-container>

				<ng-container *ngIf="controller.type === controller.EventAttendanceType.Registration">
					<info-line icon="./assets/icons/calendar-outline.svg">
						<p>{{controller.event?.startsAt | date:"EEEE d MMM yyyy"}} | {{controller.event?.startsAt | date:"HH:mm"}} - {{controller.event?.endsAt | date:"HH:mm"}}</p>
					</info-line>				
				</ng-container>

				<info-line icon="./assets/icons/attendance-type-outline.svg" align="top">
					<p><b [translate]="'EVENT.ATTENDANCE_TYPE_TITLE'"></b></p>
					<ng-container [ngSwitch]="controller.type">
						<p *ngSwitchCase="controller.EventAttendanceType.Reservation">{{'EVENT_ATTENDANCE_TYPE.RESERVATION' | translate}}</p>
						<p *ngSwitchCase="controller.EventAttendanceType.Registration">{{'EVENT_ATTENDANCE_TYPE.REGISTRATION' | translate}}</p>
						<p *ngSwitchCase="controller.EventAttendanceType.WalkIn">{{'EVENT_ATTENDANCE_TYPE.WALKIN' | translate}}</p>
						<p *ngSwitchCase="controller.EventAttendanceType.Lessons">{{'EVENT_ATTENDANCE_TYPE.LESSONS' | translate}}</p>
					</ng-container>
				</info-line>

				<ng-container *ngIf="controller.event?.locationType === controller.EventLocationType.OnLocation">
					<info-line icon="./assets/icons/location-outline.svg" align="top">
						<p><b>{{controller.event?.Location?.place}}</b></p>
						<p [navigate]="[controller.InternalNavigationType.address, controller.event?.Location?.Address]">{{controller.event?.Location?.Address | address}}</p>
					</info-line>
				</ng-container>
					
				<ng-container *ngIf="controller.event?.locationType === controller.EventLocationType.Online">
					<info-line icon="./assets/icons/online-event-outline.svg" align="top">
						<p><b [translate]="'EVENT.IS_ONLINE_EVENT'"></b></p>
						<p class="_url" [navigate]="[controller.InternalNavigationType.url, controller.event?.url]">{{controller.event?.url}}</p>
					</info-line>
				</ng-container>

				<info-line icon="./assets/icons/created-by-outline.svg" align="top" *ngIf="controller.event?.CreatedBy?.email">
					<p><b><span>{{'EVENT.CREATED_BY' | translate}}: </span></b><span [navigate]="[controller.InternalNavigationType.email, controller.event.CreatedBy?.email]">{{controller.event.CreatedBy?.email}}</span> 
						<span style="color: grey"> ({{controller.event.createdAt | date:"EEEE d MMM yyyy"}})</span>
					</p>
				</info-line>

				

				@if (controller.reservation?.isPublic) {
					<info-line icon="./assets/icons/created-by-outline.svg" align="top">
						<p><b><span>{{'RESERVATION.CREATED_BY_PUBLIC_USER' | translate}} </span></b>
							<span style="color: grey"> ({{controller.reservation.createdAt | date:"EEEE d MMM yyyy"}})</span>
						</p>
					</info-line>
				} @else if (controller.reservation?.CreatedBy?.email) {
					<info-line icon="./assets/icons/created-by-outline.svg" align="top">
						<p><b><span>{{'RESERVATION.CREATED_BY' | translate}}: </span></b><span [navigate]="[controller.InternalNavigationType.email, controller.reservation.CreatedBy.email]">{{controller.reservation.CreatedBy.email}}</span> 
							<span style="color: grey"> ({{controller.reservation.createdAt | date:"EEEE d MMM yyyy"}})</span>
						</p>
					</info-line>
				}
			</div>
		</ng-container>



		<!-- CONFIRMATION LEFT -->
		<ng-container *ngIf="controller.showConfirmation">
			<div class="_header">
				<p class="_title" [translate]="controller.type === controller.EventAttendanceType.Reservation ? 'RESERVATION.COMPLETED' : 'REGISTRATION.COMPLETED'"></p>
			</div>

			<div class="_info _actionable" *ngIf="controller.type !== controller.EventAttendanceType.WalkIn" >
				<p [translate]="'PRINT_INFO'"></p>
			</div>
		</ng-container>
		
	</ng-container>

	<!-- RIGHT -->
	<ng-container right>

		<!-- CREATE RESERVATION -->
		<ng-container *ngIf="!controller.showConfirmation">
			<!-- CLIENT DETAILS -->
			<div class="_client-details" *ngIf="controller.action === 'update' && controller.reservation?.Client">
				<p class="_title" [translate]="'CLIENT.TITLE'"></p>
				<client-details-component [client]="controller.reservation.Client"></client-details-component>

				<div class="_attendance" *ngIf="controller.attendancesVisible" > 

					<ng-container *ngIf="controller.reservation.Attendance?.status === controller.AttendanceStatus.Present; else absent">
						<info-line icon="./assets/icons/present-outline.svg">
							<p><b>{{'RESERVATION.PRESENT_LONG' | translate}}</b></p>
						</info-line>
					</ng-container>
					<ng-template #absent>
						<info-line icon="./assets/icons/absent-outline.svg">
							<p><b>{{'RESERVATION.ABSENT_LONG' | translate}}</b></p>
						</info-line>
					</ng-template>

				</div> 
			</div>

			<!-- When reservation is cancelled -->
			<div class="_reservation-cancellation" *ngIf="!controller.reservation?.isActive && controller.reservation?.cancelledAt">

				<p  class="_title" [translate]="'RESERVATION.CANCELLATION_DETAILS'"></p>
				
				<info-line icon="./assets/icons/calendar-outline.svg" align="top" *ngIf="controller.reservation.cancelledAt">
					<p><b [translate]="'RESERVATION.CANCELLATION_AT'"></b></p>
					<p><span> {{'ON_THE' | translate}} {{controller.reservation.cancelledAt | date:"dd/MM/yyyy"}} {{'AT' | translate}} {{controller.reservation.cancelledAt | date:"HH:mm"}}</span></p>
				</info-line>
				
				<info-line icon="./assets/icons/info-outline.svg" align="top" *ngIf="controller.reservation.CancellationReason?.name || controller.reservation.cancellationInfo">
					<p><b [translate]="'RESERVATION.CANCELLATION_REASON'"></b></p>
					<p>
						<span>{{controller.reservation.CancellationReason?.name}}</span>
						<span *ngIf="controller.reservation.cancellationInfo && controller.reservation.CancellationReason?.name"> - </span>
						<span>{{controller.reservation.cancellationInfo}}</span>
					</p>
				</info-line>

				<info-line icon="./assets/icons/user-outline.svg" align="top" *ngIf="controller.reservation.CancelledBy?.email">
					<p><b [translate]="'RESERVATION.CANCELLED_BY'"></b></p>
					<p [navigate]="[controller.InternalNavigationType.email, controller.reservation.CancelledBy?.email]">{{controller.reservation.CancelledBy?.email}}</p>
				</info-line>

			</div>

			<ng-container *ngIf="controller.reservationForm">
				<form [formGroup]="controller.reservationForm" *ngIf="controller.reservationForm && (controller.action === controller.Action.CREATE || controller.reservation?.isActive)">	
						
					<ng-container *ngIf="(controller.action === controller.Action.UPDATE) && controller.type === controller.EventAttendanceType.Reservation && controller.reservations?.length > 1 && !controller.isInPast">
						<form-select label="{{ 'RESERVATION.DATE_TIME' | translate }}" [formControl]="controller.reservationForm.get('id') | cast" [items]="controller.reservations" bindValue="id" [multiple]="false" [template]="template" [readonly]="controller.isInPast">
							<ng-template let-item #template> 
								<div class="_reservation">
									<p class="_date-time">{{item.startsAt | date:"EEEE d MMM yyyy" }}: <b>{{item.startsAt | date:"HH:mm"}} - {{item.endsAt | date:"HH:mm"}}</b></p>
								</div>
							</ng-template>
						</form-select>
					</ng-container>

					<ng-container *ngIf="controller.action === controller.Action.CREATE && controller.reservationForm.get('Client')">
						<form-client [formGroup]="controller.reservationForm.get('Client') | cast" [clientLocked]="controller.clientLocked" (navigatingToClient)="controller.useNavigationDataManager()"></form-client>
					</ng-container>

					<ng-container *ngIf="controller.isFromWaitList && controller.type === controller.EventAttendanceType.Reservation && controller.reservations?.length >= 1 && !controller.isInPast">
						<form-select label="{{ 'RESERVATION.DATE_TIME_FROM_WAIT_LIST' | translate }}" [formControl]="controller.reservationForm.get('id') | cast" [items]="controller.reservations" bindValue="id" [multiple]="false" [template]="template" [readonly]="controller.isInPast">
							<ng-template let-item #template> 
								<div class="_reservation">
									<p class="_date-time">{{item.startsAt | date:"EEEE d MMM yyyy" }}: <b>{{item.startsAt | date:"HH:mm"}} - {{item.endsAt | date:"HH:mm"}}</b></p>
								</div>
							</ng-template>
						</form-select>
					</ng-container>

					<form-select label="{{ 'EVENT.DIGIBANK_OBJECTIVE.TITLE' | translate }}" [formControl]="controller.reservationForm.get('digibankObjective') | cast" [items]="controller.digibankObjectives" bindValue="value" bindLabel="label" [multiple]="false">
					</form-select>	

					<p class="_title">{{'TEMPLATE_VARIABLES.QUESTION_TITLE' | translate}}</p>

					<form-select 
						label="{{ 'RESERVATION.QUESTION_CATEGORY' | translate }}" 
						[formControl]="controller.reservationForm.get('Attendance.QuestionCategories') | cast" 
						[items]="controller.questionCategories" 
						bindValue="id" 
						bindLabel="name" 
						[multiple]="true" 
						position="top" 
					>
						<ng-container *ifUserHasPermissions="[controller.UserPermissions.WriteConfigurations]" add-button>
							<button class="_button _add-button" (click)="createQuestionCategory()">
								<ion-icon src="./assets/icons/add-outline.svg"></ion-icon>
							</button>
						</ng-container>
					</form-select>

					<form-textarea label="{{ 'RESERVATION.QUESTION' | translate }}" [formControl]="controller.reservationForm.get('question') | cast" ></form-textarea>
					
					<ng-container *ngIf="controller.action === controller.Action.UPDATE && controller.reservation?.Client?.Loans?.length">
						<p class="_subtitle" [translate]="'RESERVATION.LOANS'"></p>
						<div class="_loans-container">
							<div class="_loan-container" *ngFor="let loan of controller.reservation?.Client.Loans" (click)="controller.openLoan(loan)">
								<p class="_loan-date"><b>{{'LOAN.STARTS_AT' | translate}}: </b>{{loan.startsAt | date:"EEEE d MMM yyyy"}}</p>
								<p class="_loan-date"><b>{{'LOAN.ENDS_AT' | translate}}: </b>{{loan.endsAt | date:"EEEE d MMM yyyy"}}</p>
								<div *ngFor="let device of loan.Devices">
									<p class="_device"><b>{{device.DeviceType.name}}</b> ({{device.serial}})</p>
								</div>
							</div>
							<ng-container *ifUserHasPermissions="[controller.UserPermissions.ReadLoans]">
								<div class="_add-loan" (click)="controller.openLoan()" *ngIf="!controller.isInPast">
									<ion-icon src="./assets/icons/add.svg"></ion-icon>
									<span [translate]="'RESERVATION.ADD_LOAN'"></span>
								</div>
							</ng-container>
						</div>
					</ng-container>

					<ng-container *ngIf="controller.communication && !controller.isInPast && controller.type !== controller.EventAttendanceType.WalkIn">
						<p class="_title">{{'COMMUNICATION.TITLE_SHORT' | translate}}</p>
						<form-communication-component [replyTo]="controller.reservationForm.get('replyTo') | cast" [telephone]="controller.reservationForm.get('telephone') | cast" [communication]="controller.communication"></form-communication-component>
					</ng-container>
					
				</form>
			</ng-container>

			@if (controller.reservation?.Rating) {
				<div class="_rating-container">

					<p class="_title" [translate]="'RESERVATION.RATING'"></p>

					<info-line icon="./assets/icons/rating-outline.svg" class="_rating-score-container">
						<p class="_rating-score">
							<span class="_rating-score-star-container">
								@for (i of [1,2,3,4,5]; track $index) {
									@if (controller.reservation.Rating.score >= i) {
										<ion-icon src="./assets/icons/star.svg"></ion-icon>
									} @else {
										<ion-icon style="color: lightgrey" src="./assets/icons/star-outline.svg"></ion-icon>
									}
									
								}
							</span>
						</p>
					</info-line>

					@if (controller.reservation.Rating.note) {
						<info-line icon="./assets/icons/chat-outline.svg">
							<p>{{controller.reservation.Rating.note}}</p>
						</info-line>
					}

					<info-line icon="./assets/icons/calendar-outline.svg">
						<p>{{(controller.reservation.Rating.finishedAt ?? controller.reservation.Rating.createdAt) | date:'dd/MM/yyyy'}}</p>
					</info-line>

				</div>
			}
		</ng-container>



		<!-- CONFIRMATION -->
		<div class="_confirmation" *ngIf="controller.showConfirmation">
			<p class="_title">{{controller.reservation.Event.EventType.name}} {{controller.reservation.Event.name}}</p>


			<ng-container *ngIf="controller.event.attendanceType !== controller.EventAttendanceType.Lessons; else lessons">
				<info-line icon="./assets/icons/calendar-outline.svg">
					<p>{{controller.reservation.CalendarEvent.startsAt | date:'E dd/MM/yyyy'}}</p>
				</info-line>
				
				<info-line icon="./assets/icons/time-outline.svg">
					<ng-container *ngIf="controller.type === controller.EventAttendanceType.Registration || controller.EventAttendanceType.WalkIn">
						<p>{{controller.reservation.CalendarEvent.startsAt | date:"HH:mm"}} - {{controller.reservation.CalendarEvent.endsAt | date:"HH:mm"}}</p>
					</ng-container>
					<ng-container *ngIf="controller.type === controller.EventAttendanceType.Reservation">
						<p>{{controller.reservation.startsAt | date:"HH:mm"}} - {{controller.reservation.endsAt | date:"HH:mm"}}</p>
					</ng-container>
				</info-line>
			</ng-container>

			<ng-template #lessons>
				<info-line icon="./assets/icons/calendar-outline.svg" align="top">
					<p>{{'EVENT_ATTENDANCE_TYPE.LESSONS' | translate}}:</p>
					<div *ngFor="let lesson of controller.event.Lessons" class="_lessons">
						<div class="_lesson">
							<p class="_label">
								<b>{{lesson.name}}:</b> {{lesson.CalendarEvent.startsAt | date:"EEEE dd/MM/yyyy"}} | {{lesson.CalendarEvent.startsAt | date:"HH:mm"}} - {{lesson.CalendarEvent.endsAt | date:"HH:mm"}}
							</p>
						</div>
					</div>					
				</info-line>
			</ng-template>

			<ng-container *ngIf="controller.event?.locationType === controller.EventLocationType.OnLocation">
				<info-line icon="./assets/icons/location-outline.svg" align="top">
					<p><b>{{controller.event?.Location?.place}}</b></p>
					<p [navigate]="[controller.InternalNavigationType.address, controller.event?.Location?.Address]">{{controller.event?.Location?.Address | address}}</p>
				</info-line>
			</ng-container>
				
			<ng-container *ngIf="controller.event?.locationType === controller.EventLocationType.Online">
				<info-line icon="./assets/icons/online-event-outline.svg" align="top">
					<p><b [translate]="'EVENT.IS_ONLINE_EVENT'"></b></p>
					<p class="_url" [navigate]="[controller.InternalNavigationType.url, controller.event?.url]">{{controller.event?.url}}</p>
				</info-line>
			</ng-container>

			<p  class="_title" [translate]="'RESERVATION.CONTACT'"></p>
			<p class="_confirmation-subtitle" [translate]="'RESERVATION.CONTACT_INFO'"></p>

			<info-line icon="./assets/icons/email-outline.svg">
				<p>{{controller.reservation.replyTo}}</p>
			</info-line>

			<info-line icon="./assets/icons/phone-outline.svg">
				<p>{{controller.reservation.telephone}}</p>
			</info-line>

			<p  class="_title" [translate]="'RESERVATION.PARTICIPANT_DATA'"></p>
			<info-line icon="./assets/icons/user-outline.svg">
				<p>
					<span [navigate]="[controller.InternalNavigationType.page, '/internal/clienten/client', [controller.NavigationDataKey.client, controller.reservation.Client]]">
						{{controller.reservation.Client.firstname}} {{controller.reservation.Client.lastname}}
					</span>
				</p>
			</info-line>
		
			<info-line icon="./assets/icons/phone-outline.svg">
				<p [navigate]="[controller.InternalNavigationType.phone, controller.reservation.Client.telephone]">{{controller.reservation.Client.telephone}}</p>
			</info-line>
		
			<info-line icon="./assets/icons/email-outline.svg">
				<p [navigate]="[controller.InternalNavigationType.email, controller.reservation.Client.email]">{{controller.reservation.Client.email}}</p>
			</info-line>
			
		</div>

		
	</ng-container>

	<!-- BUTTONS -->
	<ng-container buttons>
		
		<!-- NOT CONFIRMATION-->
		<ng-container *ngIf="!controller.showConfirmation && !controller.reservationLocked">

			<ng-container *ngIf="(controller.action === controller.Action.CREATE || controller.reservation?.isActive)">
				<!-- UPDATE -->
				<ng-container *ngIf="controller.action !== controller.Action.CREATE; else create">
					<button type="button" class="_button _delete-button" [translate]="controller.type === controller.EventAttendanceType.Reservation ? 'RESERVATION.DELETE' : 'REGISTRATION.DELETE'" (click)="deleteReservation()"></button>
					<button class="_button _save-button" [translate]="controller.type === controller.EventAttendanceType.Reservation ? 'RESERVATION.UPDATE' : 'REGISTRATION.UPDATE'" (click)="controller.updateReservation()"></button>
				</ng-container>

				<!-- CREATE-->
				<ng-template #create>
					<button *ngIf="controller.type === controller.EventAttendanceType.Reservation" class="_button _save-button" [translate]="'RESERVATION.CREATE'" (click)="controller.reserve()"></button>
					<button 
						*ngIf="controller.type === controller.EventAttendanceType.Registration || controller.type === controller.EventAttendanceType.WalkIn || controller.type === controller.EventAttendanceType.Lessons" 
						class="_button _save-button" 
						[translate]="'REGISTRATION.CREATE'" 
						(click)="controller.register()"
					></button>
				</ng-template>
			</ng-container>
	
			<button class="_button _cancel-button" [translate]="'EVENT.CANCEL'" (click)="controller.close()"></button>
		</ng-container>

		<!-- CONFIRMATION -->
		<ng-container *ngIf="controller.showConfirmation || controller.reservationLocked">

			<button class="_button _print-button" (click)="print()" *ngIf="!(controller.event?.attendanceType === controller.EventAttendanceType.WalkIn && controller.showConfirmation)">
				<ion-icon src="./assets/icons/print-outline.svg"></ion-icon>
				<span [translate]="'EVENT.PRINT'"></span>
			</button>

			<button class="_button _cancel-button" [translate]="'CONTINUE'" (click)="controller.close()"></button>
		</ng-container>

	</ng-container>

</modal-component>